export const getProviderFromHost = () => {
  if (typeof window === 'undefined') return null;

  const host = window.location.hostname;

  if (host === 'localhost' || host === '127.0.0.1') {
    return null;
  }

  const subdomain = host.split('.')[0]?.toLowerCase();

  const TENANT_SUBDOMAINS = ['maentae'];

  if (TENANT_SUBDOMAINS.includes(subdomain)) {
    return null;
  }
  return subdomain;
};
